<template>
		<div class="content ac-page">
		<Header></Header>
      <div class="chances-top disflex crfff ac">
        <div @click="back">
          <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
          <div>{{$t('Back')}}</div>
        </div>
      </div>
			<div class="info ac crfff">
        <div class="nav ac" style="margin-top: -0.3rem;">
          <span class="">{{$t('PurchaseChances')}}</span>
        </div>
        <div class="ac" style="margin-top: -1rem;margin-bottom: -0.5rem;">
          <img width="80%" src="../../static/images/Crystals.png" />
        </div>
        <div class="fs22 mt20 ac">{{$t('purchaseTips1')}} : {{score}}</div>
        <div class="list mt30">
          <div class="li" v-if="!isShow" @click="getSub('daily')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
            <strong>{{$t('Daily')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('DailyKyats')}}
            </div>
          </div>
          <div class="li" v-if="!isShow" @click="getSub('weekly')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
            <strong>{{$t('Weekly')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('WeeklyKyats')}}
            </div>
          </div>
        </div>

          <div class="li mt30" :class="{'disabled':!isShow}" @click="getBuy(1)">
            <strong>{{$t('OneTime')}} {{$t('Purchase')}}</strong>
            <div class="rf">
              {{$t('OneTimeChance')}}
            </div>
          </div>
        <button class="button mt30" @click="getBuy(1)">{{$t('BuyNow')}}</button>
			</div>
      <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
          <div class="alert-modal ac" slot="mdBox" >
              <div class="close" @click="closeTmgDialog" style="text-align: right;margin-right: -10px;">
                <img width="40" src="../../static/images/close.png" />
              </div>
              <div class="por" style="width: 3rem;margin: 0 auto;background: #1a266a;box-shadow: 0 0 30px #f4c214;border-radius: 100%;">
                <img style="width:3rem" src="../../static/images/img1.png" />
                <div class="circle"></div>
              </div>
              <div class="fs33 mt50 ac">{{$t('purchaseTips2')}}</div>
<!--              <div class="fs26 ac" v-html="$t('purchaseTips3')"></div>-->
<!--              <div class="flex mt20" style="justify-content: center;">
                <img width="80" @click="getShao" src="../../static/images/shao.png" />
                <input type="number" style="background:#dadbe1;text-align: center;color:#1a266a;width: 160px;" v-model="num" class="input" />
                <img width="80" @click="getAdd" src="../../static/images/add.png" />
              </div>-->
              <button class="button mt30" @click="getBuy(2)">{{$t('BuyNow')}}!</button>
          </div>
      </Dialog>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:true,
       score:'',
        num:1,
        info:{}
      }
    },
	created(){
		this.getHome();
	},
  methods: {
    getShao(){
      if(this.num==1){
        return;
      }
      this.num--
    },
    getAdd(){
      this.num++
    },
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.post('/api/index/check_sub',null,r =>{
				that.$parent.returnCode(r,function(){
          that.isShow = r.data.sub_status
          that.score = r.data.score
					that.$parent.loadModal(false);
				});

			})

		},
    getSub(type){
      let that =this;
      let data = {
        type:type
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/index/sub',data,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,50, 2000);
      	});

      })
    },
    getBuy(type){
      let that = this
      if(type==1){
        if(!that.isShow){
          return
        }
        that.num = 1
        that.$refs.imgDialog.showMaskFun();
      }else{
        let data = {
          num:this.num
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/index/buy',data,r =>{
        	that.$parent.returnCode(r,function(){
        		that.$parent.loadModal(false);
            that.$utils.alertText(r.msg,100,3000);
            that.$refs.imgDialog.closeMask();
            that.num = 1
            that.getHome()
        	});

        })
      }
    },
    closeTmgDialog(){
      this.$refs.imgDialog.closeMask();
    },
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/purchaseChances.vue